const ALLOWED_CHARACTERS_REGEX = /[^a-z0-9_]/gi;
const REPLACE_CHARACTERS_REGEX = /[- ]/g;

const ALLOWED_PARAM_CHARACTERS_REGEX = /[^A-Za-z0-9_~+*-]/gi;
const REPLACE_PARAM_CHARACTERS_REGEX = /[ ]/g;

const ALLOWED_TAG_CHARACTERS_REGEX = /[^a-z0-9_-]/gi;

export const sanitizeInputValue = (value) => {
  return value.toLowerCase().replace(REPLACE_CHARACTERS_REGEX, '_').replace(ALLOWED_CHARACTERS_REGEX, '');
};

export const sanitizeParamValue = (value) => {
  return value.toLowerCase().replace(REPLACE_PARAM_CHARACTERS_REGEX, '_').replace(ALLOWED_PARAM_CHARACTERS_REGEX, '');
};

export const sanitizeRulenameOnKeyUp = (value) => {
  return sanitizeInputValue(value);
};

export const sanitizeTagValue = (value) => {
  return value.toLowerCase().replace(REPLACE_CHARACTERS_REGEX, '-').replace(ALLOWED_TAG_CHARACTERS_REGEX, '');
};
